import React from 'react';
import PropTypes from 'prop-types';

const paragraph = (props) => {
  const { classes } = props;

  return (
    <p className={[props.center && 'justifycentre', classes && classes].join(' ')}>
      {props.children}
    </p>
  );
};

paragraph.propTypes = {
  center: PropTypes.bool,
  classes: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string, PropTypes.number]).isRequired,
};

paragraph.defaultProps = {
  center: false,
  classes: null,
};

export default paragraph;



// WEBPACK FOOTER //
// ./src/Components/Paragraph/index.jsx